import { CHART_LAYOUTS } from '../../utils/chartLayouts';

/**
 * TradingView-style numbered multi-chart layout picker.
 * Renders mini grid previews for each arrangement.
 */
function LayoutIcon({ layout }) {
  const cells = Array.from({ length: layout.panes }, (_, i) => String.fromCharCode(97 + i));
  return (
    <div
      className="tv-layout-icon"
      style={{
        gridTemplateColumns: layout.cols,
        gridTemplateRows: layout.rows,
        gridTemplateAreas: layout.areas.map((r) => `"${r}"`).join(' '),
      }}
    >
      {cells.map((area) => (
        <span key={area} style={{ gridArea: area }} className="tv-layout-icon-cell" />
      ))}
    </div>
  );
}

export default function ChartLayoutSelector({
  value,
  onChange,
  open,
  onClose,
}) {
  if (!open) return null;

  return (
    <div className="tv-layout-panel" role="dialog" aria-label="Chart layout">
      <div className="tv-layout-panel-hdr">
        <span>Select Layout</span>
        <button type="button" className="tv-icon-btn" onClick={onClose} title="Close">
          <i className="bi bi-x-lg" />
        </button>
      </div>
      <div className="tv-layout-grid">
        {CHART_LAYOUTS.map((layout) => (
          <button
            key={layout.id}
            type="button"
            className={`tv-layout-option${value === layout.id ? ' active' : ''}`}
            title={layout.title}
            onClick={() => {
              onChange?.(layout.id);
              onClose?.();
            }}
          >
            <LayoutIcon layout={layout} />
            <span className="tv-layout-num">{layout.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
